<template>

  <modal-layout
    :bgShow="error.show"
    :modalShow="error.show"
    @close="close">

    <div
      class="warning-modal" v-if="error.type!='manualStart'">
      <div
        class="warning-modal__head">
        <img
          src="@/../static/img/icons/warning.svg">
        Ошибка
      </div>
      <div
        class="warning-modal__body">
        <div v-if="error.type=='icloud'">
          Устройство не было отключено от iCloud. Отключите устройство и отправьте новый запрос на проверку через 2 минуты
        </div>
        <div v-if="error.type=='notAllDataEntered'">
          Вы не заполнили все данные, пожалуйста проверьте и попробуйте ещё раз!
        </div>
        <div v-if="error.type=='notNewIMEI'">
          IMEI нового устройства отсутствует, пожалуйста введите его
        </div>
        <div v-if="error.type=='notIMEI'">
          IMEI выкупаемого устройства отсутствует, пожалуйста введите его
        </div>
        <div v-if="error.type=='invalidIdentifier' || error.type=='possibleEid'">
          {{ error.message }}
        </div>
        <div v-if="error.type=='manual'">
          Вы не завершили процесс оформления TradeIn в боте
        </div>
        <div v-if="error.type=='manualChangeGrade'">
          Оценка изменилась. Пожалуйста, ознакомьте с ней клиента
        </div>
        <div v-if="error.type=='mtsTechnicalGradeChanged'">
          Обратите внимание, грейд и цена устройства изменилась. Новый грейд - {{ error.grade }}, новая цена - {{ error.price }} {{ error.currency }}
        </div>
        <div v-if="error.type=='buyoutSideUnknown'">
          {{ error.message || 'Невозможно определить сторону выкупа. Обратитесь в службу поддержки.' }}
        </div>
        <div v-if="error.type=='articleColorGradeUnavailable'" class="article-validation-error">
          <p>{{ error.message }}</p>
          <div
            v-if="articleValidationRows.length"
            class="article-validation-error__details">
            <div
              v-for="row in articleValidationRows"
              :key="row.key"
              class="article-validation-error__line">
              <strong>{{ row.label }}:</strong> {{ row.value }}
            </div>
          </div>
        </div>


        <div v-if="error.type=='scorring'">
          <h2>Подтверждение состояния устройства:</h2>
          <p>Для этого вам нужно отправить фото выкупаемого устройства в Telegram боте</br>
          Ваша уникальная ссылка для перехода в бот: <a target="_blank" :href="'https://t.me/tki_tradein_bot?start=' + model.btag">https://t.me/tki_tradein_bot?start={{model.btag}}</a></p>
          <p class="qrcode_text">QR код для перехода в бота:</p>
          <qr-code :text="'https://t.me/tki_tradein_bot?start=' + model.btag"></qr-code>
        </div>
        <div v-if="error.type=='scorringRefuse'">
          Устройство не прошло проверку на состояние, проведите оценку устройства повторно и внимательно отвечайте на вопросы
        </div>
      </div>
      <div
        class="warning-modal__footer">
        <button
          class="btn cancel"
          @click.prevent="send()">
          Закрыть
        </button>
      </div>
    </div>
    <div
      class="warning-modal" v-if="error.type=='manualStart'">
      <div
        class="warning-modal__head" style="background-color: cornflowerblue;">
        Оформление заявки
      </div>
      <div
        class="warning-modal__body">
        <div>
          Отлично, теперь вы можете продолжить оформление в телеграм боте.
        </div>
      </div>
      <div
        class="warning-modal__footer">
        <button
          class="btn cancel"
          @click.prevent="send()">
          Закрыть
        </button>
      </div>
    </div>

  </modal-layout>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import ModalLayout from './ModalLayout';

export default {
  components: {
    ModalLayout,
  },
  computed: {
    ...mapState('buyphones', ['model', 'questions', 'answers', 'error']),
    articleValidationRows() {
      const validation = this.error.articleValidation || {};
      const fields = [
        { key: 'manufacturer', label: 'Производитель' },
        { key: 'model', label: 'Модель' },
        { key: 'storage', label: 'Память' },
        { key: 'color', label: 'Цвет' },
        { key: 'grade', label: 'Грейд' },
      ];

      return fields
        .filter(field => validation[field.key])
        .map(field => ({
          ...field,
          value: validation[field.key],
        }));
    },
  },
  methods: {
    ...mapActions('buyphones', ['getCalc']),
    ...mapMutations('buyphones', ['SET_ERROR']),

    close() {
      this.SET_ERROR({ show: false, type: '' });
    },

    send() {
      // this.getCalc({
      //   btag: this.model.btag,
      //   questions: this.answers,
      // })
      this.SET_ERROR({ show: false, type: '' });
    },
  },
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/warning-modal.sass'
</style>
